import { DefensoraProps } from './Defensora.types';
import __isEmpty from 'lodash/isEmpty';
// @ts-ignore
import Imatge from 'components/corporatiu/Imatge';
import styles from './defensora.module.scss';
// @ts-ignore
import DesplegableComponent from 'components/corporatiu/Desplegable'
const Desplegable: any = DesplegableComponent;
// @ts-ignore
import Text from 'components/corporatiu/Text';

const Defensora = (props: Readonly<DefensoraProps>) => {
    const { items } = props;
    return (
        <>
            <div className={styles.defensora}>
                <div className={styles.entradeta}>
                    <Text text={items?.entradeta} />
                </div>
                <div className={styles.desplegables}>
                    {!__isEmpty(items) &&
                        items?.desplegables?.map((item, index) => (
                            <div key={index}>
                                <>
                                    <Desplegable titol={item?.titol} className={styles.textDesplegable}>
                                        <div className={styles.contingutDesplegable}>
                                            <Text text={item?.text} />
                                        </div>
                                    </Desplegable>
                                </>
                            </div>
                        ))}
                </div>
                <div className={styles.imatge}>
                    <span className={styles.imatgeApp}>
                        <Imatge
                            src={'https://img.3cat.cat/multimedia/jpg/9/5/1456314540159_215x373.jpg'}
                            loading='eager'
                            width={215}
                            height={373}
                            alt={'Laura Baladas'}
                        ></Imatge>
                    </span>
                </div>
            </div>
            <div className={styles.preIframe}>
                <p>
                    Les competències directes de la Defensora de l&apos;Audiència se centren en àmbits com la protecció dels
                    menors, la imatge de les persones, la igualtat, el dret a la intimitat o l&apos;honor. Si la vostra consulta,
                    suggeriment, aportació o queixa es refereix a algun d&apos;aquests àmbits li podeu fer arribar directament.
                </p>
            </div>
            <iframe
                title='Formulari de contacte Defensora'
                id='iframeDef'
                name='iframeDef'
                frameBorder='0'
                src='https://registre-saa.3cat.cat/saa/contacte/defensora.jsf'
                width='100%'
                height='1380'
            ></iframe>
        </>
    );
};

export default Defensora;
